import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import _, { find, get } from 'lodash';
import Fuse from 'fuse.js';

import { setPrevalenceSelectedCountry } from '../actions/actionCreators';

class Searchbar extends React.Component {
	constructor(props) {
		super(props);
		this.searchInputRef = React.createRef();

		this.state = {
			searchInput: '',
			resultCountries: [],
			showResultDropdown: false,
			hasInput: false,
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.clearSearch = this.clearSearch.bind(this);
		this.handleSearchIconClick = this.handleSearchIconClick.bind(this);
		this.handleCountryClick = this.handleCountryClick.bind(this);

		this.prevalenceMapFuse = new Fuse(this.props.dataForList.prevalence.countries, {
			includeScore: true,
			keys: ['ISO', 'iso', 'name', 'aliases'],
			threshold: 0.3,
		});

		this.travelMapFuse = new Fuse(this.props.dataForList.travel, {
			includeScore: true,
			keys: ['ISO', 'iso', 'name', 'aliases'],
			threshold: 0.3,
		});
	}

	componentWillMount() {
		this.unlisten = this.props.history.listen((location, action) => {
			this.setState({
				searchInput: '',
				resultCountries: [],
				showResultDropdown: false,
				hasInput: false,
			});
		});
	}
	componentUpdate() {
		this.unlisten();
	}

	handleSearchIconClick() {
		this.searchInputRef.current.focus();
	}

	handleInputChange(event, type) {
		let value = event.target.value;
		let searchResult;

		if (type == 'prevalenceMap') {
			searchResult = _.map(this.prevalenceMapFuse.search(value), 'item');
		} else if (type == 'travelMap') {
			searchResult = _.map(this.travelMapFuse.search(value), 'item');
		}

		if (value.length >= 3) {
			this.setState({
				searchInput: value,
				resultCountries: searchResult,
				showResultDropdown: true,
				hasInput: true,
			});
		} else if (value.length == 0) {
			this.setState({
				searchInput: '',
				resultCountries: [],
				showResultDropdown: false,
				hasInput: false,
			});
		} else {
			this.setState({
				searchInput: value,
				resultCountries: [],
				showResultDropdown: false,
				hasInput: true,
			});
		}
	}

	handleCountryClick(countryCode) {
		this.clearSearch();

		const country = this.props.dataForList.prevalence.countries.find((country) => country.iso === countryCode);
		// to get country lat & lug
		const countryInfo = _.find(this.props.features, (el) => _.get(el, 'properties.iso_a2') === countryCode);
		this.props.setPrevalenceSelectedCountry(
			country,
			countryInfo.properties.center.lat,
			countryInfo.properties.center.lng
		);
	}

	clearSearch() {
		this.setState({
			searchInput: '',
			resultCountries: [],
			showResultDropdown: false,
			hasInput: false,
		});
	}

	render() {
		const prevalenceActive = this.props.history.location.pathname.includes(`/${window.prevalence_tab_slug}`);
		const travelActive = this.props.history.location.pathname.includes('/travel');
		return (
			<div className="searchbar">
				<div
					className="icon icon-search-black"
					onClick={() => {
						this.handleSearchIconClick();
					}}
				/>

				{prevalenceActive === true && (
					<input
						ref={this.searchInputRef}
						type="search"
						placeholder="Search countries"
						onChange={(event) => {
							this.handleInputChange(event, 'prevalenceMap');
						}}
						value={this.state.searchInput}
					/>
				)}

				{travelActive === true && (
					<input
						ref={this.searchInputRef}
						type="search"
						placeholder="Search countries"
						onChange={(event) => {
							this.handleInputChange(event, 'travelMap');
						}}
						value={this.state.searchInput}
					/>
				)}

				{this.state.hasInput && (
					<div
						className="icon icon-clear"
						onClick={() => {
							this.clearSearch();
						}}
					/>
				)}

				{this.state.showResultDropdown && (
					<div className="searchbar__result">
						{prevalenceActive === true &&
							(this.state.resultCountries.length > 0 ? (
								this.state.resultCountries.map((country, i) => {
									return (
										<div
											key={i}
											className="country"
											onClick={() => {
												this.handleCountryClick(country.iso);
											}}
										>
											<p>{country.name}</p>
										</div>
									);
								})
							) : (
								<p className="no-result">No countries found</p>
							))}
						{travelActive === true &&
							(this.state.resultCountries.length > 0 ? (
								this.state.resultCountries.map((country, i) => {
									if (country.ISO) {
										return (
											<Link
												key={i}
												to={`/travel/${country.ISO.toLowerCase()}`}
												onClick={() => {
													this.clearSearch();
												}}
												className="country"
											>
												<p>{country.name}</p>
											</Link>
										);
									}
								})
							) : (
								<p className="no-result">No countries found</p>
							))}
					</div>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		features: state.json.geoJSON.features,
		dataForList: state.json.data,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		setPrevalenceSelectedCountry: (country, lat, lng) => dispatch(setPrevalenceSelectedCountry(country, lat, lng)),
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Searchbar));
